import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login.vue'
import Register from '@/views/register.vue'
import Index from '@/views/index.vue'
// import Page404 from '@/views/404.vue'
// import AppHome from '@/views/layout/AppHome.vue'
import Dashboard from '@/views/dashboard.vue'
// import AppDashboard from '@/views/page/Dashboard.vue'
// import BlackBoard from '@/views/page/BlackBoard.vue'
// import ReceiptOrderList from '@/views/page/ReceiptOrderList.vue'

Vue.use(Router)

// const Login = (sesolve) => {
//   import('../views/login.vue').then((module) => {
//     sesolve(module)
//   })
// }
// const Index = (sesolve) => {
//   import('../views/index.vue').then((module) => {
//     sesolve(module)
//   })
// }

const Page404 = r => require.ensure([], () => r(require('../views/404.vue')), 'page404')
const AppHome = r => require.ensure([], () => r(require('../views/layout/AppHome.vue')), 'appHome')

// const Page404 = (sesolve) => {
//   import('../views/404.vue').then((module) => {
//     sesolve(module)
//   })
// }
// const AppHome = (sesolve) => {
//   import('../views/layout/AppHome.vue').then((module) => {
//     sesolve(module)
//   })
// }
// - const Dashboard = (sesolve) => {
// -   import('../views/dashboard.vue').then((module) => {
// -     sesolve(module)
// -   })
// - }
const AppDashboard = r => require.ensure([], () => r(require('../views/page/ldms/Dashboard.vue')), 'appDashboard')
const BlackBoard = r => require.ensure([], () => r(require('../views/page/ldms/BlackBoard.vue')), 'blackBoard')
const ReceiptOrderList = r => require.ensure([], () => r(require('../views/page/ldms/ReceiptOrderList.vue')), 'receiptOrderList')
const SupplyList = r => require.ensure([], () => r(require('../views/page/ldms/supplyList.vue')), 'supplyList')
const PersonList = r => require.ensure([], () => r(require('../views/page/ldms/personList.vue')), 'personList')
const UserInfo = r => require.ensure([], () => r(require('../views/page/user/userInfo.vue')), 'userInfo')

// const AppDashboard = (sesolve) => {
//   import('../views/page/ldms/Dashboard.vue').then((module) => {
//     sesolve(module)
//   })
// }
// const BlackBoard = (sesolve) => {
//   import('../views/page/ldms/BlackBoard.vue').then((module) => {
//     sesolve(module)
//   })
// }
// const ReceiptOrderList = (sesolve) => {
//   import('../views/page/ldms/ReceiptOrderList.vue').then((module) => {
//     sesolve(module)
//   })
// }
// const SupplyList = (sesolve) => {
//   import('../views/page/ldms/supplyList.vue').then((module) => {
//     sesolve(module)
//   })
// }
// const UserInfo = (sesolve) => {
//   import('../views/page/user/userInfo.vue').then((module) => {
//     sesolve(module)
//   })
// }
const UserMessage = r => require.ensure([], () => r(require('../views/page/user/message.vue')), 'userMessage')

// const UserMessage = (sesolve) => {
//   import('../views/page/user/message.vue').then((module) => {
//     sesolve(module)
//   })
// }
const ForGet = r => require.ensure([], () => r(require('../views/page/user/forget.vue')), 'forGet')
//
// const ForGet = (sesolve) => {
//   import('../views/page/user/forget.vue').then((module) => {
//     sesolve(module)
//   })
// }
const Finance = r => require.ensure([], () => r(require('../views/page/statistics/finance.vue')), 'finance')

// const Finance = (sesolve) => {
//   import('../views/page/statistics/finance.vue').then((module) => {
//     sesolve(module)
//   })
// }
const FinanceUser = r => require.ensure([], () => r(require('../views/page/statistics/financeUser.vue')), 'financeUser')

// const FinanceUser = (sesolve) => {
//   import('../views/page/statistics/financeUser.vue').then((module) => {
//     sesolve(module)
//   })
// }
const FinanceByYear = r => require.ensure([], () => r(require('../views/page/statistics/financeByYear.vue')), 'financeByYear')
//
// const FinanceByYear = (sesolve) => {
//   import('../views/page/statistics/financeByYear.vue').then((module) => {
//     sesolve(module)
//   })
// }
const Statisticsbox = r => require.ensure([], () => r(require('../views/page/statistics/statisticsBox.vue')), 'statisticsbox')

// const Statisticsbox = (sesolve) => {
//   import('../views/page/statistics/statisticsBox.vue').then((module) => {
//     sesolve(module)
//   })
// }
const DriverHistory = r => require.ensure([], () => r(require('../views/page/statistics/driverHistory.vue')), 'driverHistory')

// const DriverHistory = (sesolve) => {
//   import('../views/page/statistics/driverHistory.vue').then((module) => {
//     sesolve(module)
//   })
// }

const DriverOrderBySale = r => require.ensure([], () => r(require('../views/page/statistics/driverOrder.vue')), 'driverOrderBySale')

// const DriverOrderBySale = (sesolve) => {
//   import('../views/page/statistics/driverOrder.vue').then((module) => {
//     sesolve(module)
//   })
// }
const CarList = r => require.ensure([], () => r(require('../views/page/ldms/carList.vue')), 'carList')

// const CarList = (sesolve) => {
//   import('../views/page/ldms/carList.vue').then((module) => {
//     sesolve(module)
//   })
// }
const DriverList = r => require.ensure([], () => r(require('../views/page/ldms/driverList.vue')), 'driverList')

const App = r => require.ensure([], () => r(require('../views/page/ldms/appInfo.vue')), 'appInfo')
//
// const DriverList = (sesolve) => {
//   import('../views/page/ldms/driverList.vue').then((module) => {
//     sesolve(module)
//   })
// }

const routers = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: UserInfo
  },
  {
    path: '/userMessage',
    name: 'userMessage',
    component: UserMessage
  },
  {
    path: '/forget',
    name: 'forget',
    component: ForGet
  },
  {
    path: '/app/:id',
    name: 'app',
    component: AppHome,
    children: [
      {
        path: 'statistics/',
        name: 'forget',
        component: Statisticsbox,
        children: [
          {
            path: 'finance',
            meta: { title: '财务统计' },
            component: Finance
          },
          {
            path: 'financeUser',
            meta: { title: '个人统计' },
            component: FinanceUser
          },
          {
            path: 'driverHistory',
            meta: { title: '拉货历史' },
            component: DriverHistory
          },
          {
            path: 'driverOrderBySale',
            meta: { title: '车辆排名' },
            component: DriverOrderBySale
          },
          {
            path: 'financeByYear',
            meta: { title: '年度统计' },
            component: FinanceByYear
          }
        ]
      },
      {
        path: 'appDashboard',
        component: AppDashboard,
        meta: { title: '首页面板' }
      },
      {
        path: 'blackBoard',
        component: BlackBoard,
        meta: { title: '货源小黑板' }
      },
      {
        path: 'receiptList',
        component: ReceiptOrderList,
        meta: { title: '配货单列表' }
      },
      {
        path: 'person',
        component: PersonList,
        meta: { title: '用户列表' }
      },
      {
        path: 'supply',
        component: SupplyList,
        meta: { title: '经理列表' }
      },
      {
        path: 'driver',
        component: DriverList,
        meta: { title: '司机信息' }
      },
      {
        path: 'car',
        component: CarList,
        meta: { title: '车辆信息' }
      },
      {
        path: 'app',
        component: App,
        meta: { title: '配货单设置' }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: Page404
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new Router({
  mode: 'history',
  routes: routers
})

export default router
